import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class GatewayService extends BaseService {

    static url = "stripe";
    static apis = {
        createCard: { path: "card", method: "post" },
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("stripe");
    }

    createCard(data) {
        var that = this
        return new Promise((resolve, reject) => {
            that.axios({
                url: GatewayService.apis.createCard.path,
                method: GatewayService.apis.createCard.method,
                authorization: true,
                data
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error.response);
                });
        });
    }

}

export default GatewayService;